import { render, staticRenderFns } from "./MonitoringPage.vue?vue&type=template&id=1671b546&scoped=true&"
import script from "./MonitoringPage.vue?vue&type=script&lang=js&"
export * from "./MonitoringPage.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringPage.vue?vue&type=style&index=0&id=1671b546&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1671b546",
  null
  
)

export default component.exports